<template>
  <a-modal
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="1059"
    title="通话记录"
    wrapClassName="registraContainer"
    :centered="true"
    :bodyStyle="{ height: '624px' }"
  >
    <div class="body">
      <a-spin :spinning="loading">
        <a-table
          :dataSource="tableData"
          :columns="columns"
          :pagination="false"
          rowKey="cdrId"
          :row-selection="{ selectedRowKeys, onChange: onSelectChange }"
          :scroll="{ x: 1000, y: 520 }"
        >
          <!-- 呼出人， callerType主叫方类型：1患者、2医生、3bd、4医生助手-->
          <template #callerType="{ record }">
            <div class="service_person">
              <roles :solerType="record.callerType" />
              <span>{{ record.callerName }}</span>
              <auth-img :src="callIcon" />
            </div>
          </template>
          <!-- 接听人 callerType主叫方类型：1患者、2医生、3bd、4医生助手-->
          <template #calleeName="{ record }">
            <div class="service_person">
              <roles :solerType="record.calleeType" />
              <span>{{ record.calleeName }}</span>
            </div>
          </template>
          <!-- 电话时长 -->
          <template #duration="{ record, index }">
            <template v-if="record.duration">
              <div @click="play(index)" class="call_duration" v-if="!record.isPlay">
                <auth-img :src="playIcon" />
                <span>{{ renderTime(record.duration) }}</span>
              </div>
              <div v-if="record.isPlay">
                <audio :src="record.audioUrl" controls ref="audioRef"></audio>
              </div>
            </template>
            <template v-else>--</template>
          </template>
          <!-- 通话状态 -->
          <template #endStatusDesc="{ record }">
            <span :class="{ red: record.errorStatusFlag }">
              {{ record.endStatusDesc || '--' }}
            </span>
          </template>
          <template #dialIntentStr="{ record }">
            {{ record?.dialIntentStr || '--' }}
          </template>
          <!-- 操作 -->
          <template #action="{ record }">
            <span class="action" @click="handleSummary(record)">写小结</span>
          </template>
        </a-table>
      </a-spin>
    </div>
    <template #footer>
      <div class="footer">
        <a-button
          type="primary"
          class="btn"
          @click="handleClean"
          :disabled="selectedRowKeys?.length < 1"
        >
          批量清理
        </a-button>
        <a-button class="btn" @click="handleCancel">取消</a-button>
      </div>
    </template>
    <EditSummary ref="editSummaryRef" @changeTab="getData" />
  </a-modal>
</template>

<script setup>
import { ref, defineExpose, nextTick, watch } from 'vue'
import { useStore } from 'vuex'
import callIcon from '@/assets/img/chat/callIcon.png'
import playIcon from '@/assets/img/chat/playIcon.png'
import { renderTime } from '@/utils'
import { columns } from './config'
import { getPageCallAiChatSummary } from '@/api/workPlace/workOrder'
import { deletedCallAiChatSummary, getSummaryInfo } from '@/api/workPlace/summary'
import EditSummary from '@/views/WorkPlace/Container/Summary/editSummary.vue'
import { message } from 'ant-design-vue'

const store = useStore()
const tableData = ref([]) // 通话记录列表
const visible = ref(false) // 通话记录弹窗是否可见
const loading = ref(false)
const audioRef = ref(null)
const selectedRowKeys = ref([]) // 已选通话记录
const editSummaryRef = ref(null) // 编辑沟通小结组件

watch(
  () => visible.value,
  val => {
    if (val) {
      getData()
    }
  }
)

const handleCancel = () => {
  visible.value = false
}

const onSelectChange = selectedRowKey => {
  console.log('selectedRowKeys changed: ', selectedRowKey)
  selectedRowKeys.value = selectedRowKey
}

// 获取数据
const getData = async () => {
  loading.value = true
  const params = {
    pageNo: 1,
    pageSize: 999
  }
  getPageCallAiChatSummary(params)
    .then((res = {}) => {
      const { list = [] } = res
      store.dispatch('workOrder/setTodoListState', list)
      tableData.value = list
    })
    .catch(() => {
      tableData.value = []
    })
    .finally(() => {
      loading.value = false
    })
}

// 写小结
const handleSummary = async record => {
  try {
    const res = await getSummaryInfo({ chatSummaryId: record.chatSummaryId })
    const params = {
      groupInfo: res,
      isEdit: true,
      type: res.type,
      aiSummaryContents: res.type === 1 ? JSON.parse(res.contents) : res.content
    }
    editSummaryRef.value?.initModal(params)
  } catch (error) {
    console.log(error)
  }
}

// 播放录音
const play = index => {
  console.log(index)
  tableData.value.forEach(it => (it.isPlay = false))
  tableData.value[index].isPlay = true
  nextTick(() => {
    audioRef.value.play()
  })
}

// 批量清理
const handleClean = async () => {
  try {
    await deletedCallAiChatSummary({ cdrIdList: selectedRowKeys.value })
    message.success('操作成功')
    getData()
  } catch (error) {
    console.log(error)
  }
}

defineExpose({
  visible
})
</script>

<style scoped lang="scss">
.body {
  overflow: auto;
  height: 100%;
  .action {
    font-weight: 400;
    font-size: 14px;
    color: #1890ff;
    cursor: pointer;
  }
}
.service_person {
  img {
    margin-left: 8px;
    width: 16px;
    height: 16px;
  }
}
.call_duration {
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
    margin-right: 12px;
  }
}

.footer {
  display: flex;
  flex-direction: row-reverse;
  ::v-deep(.ant-btn-primary[disabled]) {
    background-color: #1890ff4d;
    color: #ffffff;
    border: 1px solid #1890ff4d;
  }
  .btn {
    padding: 0 24px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    margin-left: 22px;
    cursor: pointer;
  }
  .primary {
    color: #fff;
    background: #1890ff;
    border: 1px solid #1890ff;
  }
}
</style>
